import { useState, useEffect, FormEvent, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { listarUsuariosOrganizacao, atualizarUsuario } from '../../services/usuarios'
import { usuariosRespostaPayload } from '../../interfaces/usuarios'
import FiltrosDefault from '../FiltrosDefault'
import avatarDefault from '../../assets/img/avatarDefault.png'
import Perfil from '../../middleware/Perfil'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import ModalUsuario from '../ModalUsuariosExternos'
import LoagindBarra from '../LoadingBarra'
import '../../styles/paginaListaDados.css'
import './usuariosExternos.css'
import { toast } from 'react-toastify'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import DivSituacao from '../DivSituacao'

function UsuariosExternos() {

  const { atualizarDados, modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)
  const { search } = useLocation()

  const paramsUrl = new URLSearchParams(search)
  const idProjeto = paramsUrl.get("idProjeto")

  const navigate = useNavigate()

  const [usuarios, setUsuarios] = useState<usuariosRespostaPayload[]>([])
  const [termo, setTermo] = useState('')
  const [situacao, setSituacao] = useState("")
  const [processando, setProcessando] = useState(false)
  const [nenhumResultado, setNenhumResultado] = useState(false)
  const [usuarioSelecionado, setUsuarioSelecionado] = useState<usuariosRespostaPayload>()

  const abrirModalDadosUsuario = (usuario?: usuariosRespostaPayload) => {
    setUsuarioSelecionado(usuario)
    return modalExibir("modalUsuario")
  }

  const pesquisarUsuario = async (e: FormEvent) => {

    e.preventDefault()
    if (!idProjeto) return toast.error("Projeto não encontrado.")
    setProcessando(true)
    setNenhumResultado(false)
    try {
      const params = {
        termo,
        situacao,
        idProjeto
      }
      const resposta = await listarUsuariosOrganizacao(params)
      if (resposta.status === 200) {
        setProcessando(false)

        if (resposta.data.length === 0) {
          setNenhumResultado(true)
        }

        return setUsuarios(resposta.data)
      }
    } catch (error) {
      setProcessando(false)
      return toast.error("Ocorreu um erro ao listar os usuários da sua empresa, favor tente novamente!")
    }
  }

  const toggleUsuario = async (usuario: usuariosRespostaPayload, e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)

    try {
      const payload = {
        situacao: usuario.usuario.situacao === 'ativo' ? 'inativo' : 'ativo'
      }

      const resposta = await atualizarUsuario(usuario.usuario.id, payload)

      if (resposta.status === 200) {
        setProcessando(false)
        atualizarDados()
        return toast.success("Dados do Usuário atualizados com Sucesso.")
      }

    } catch (error: any) {
      if (error.response.status === 408) {
        setProcessando(false)
        return toast.warn("Limite de Usuários Ativos do Plano Atingido.")
      }
      setProcessando(false)
      return toast.error("Ocorreu um erro ao tentar atualizar os dados do usuário, favor tente novamente!")
    }
  }

  useEffect(() => {
    const listarUsuarios = async () => {
      setNenhumResultado(false)
      if (!idProjeto) return toast.error("Projeto não encontrado.")
      setProcessando(true)
      try {
        const params = {
          termo: "",
          situacao: "",
          idProjeto
        }
        const resposta = await listarUsuariosOrganizacao(params)
        if (resposta.data.length === 0) return setNenhumResultado(true)
        return setUsuarios(resposta.data)
      } catch (error) {
        return toast.error("Ocorreu um erro ao listar os usuários da sua empresa, favor tente novamente!")
      } finally {
        setProcessando(false);
      }
    }

    listarUsuarios()

  }, [navigate, atualizarInformacoes])

  return (
    <Perfil perfil={["master", "consultor"]}>
      <div id='paginaContainer'>
        {modal.nome === "modalUsuario" && <ModalUsuario usuario={usuarioSelecionado} />}
        {processando && <LoagindBarra />}
        {nenhumResultado && <NenhumResultadoEncontrado />}
        <FiltrosDefault termo={termo} situacao={situacao} tipo='usuário' placeholder='Pesquise pelo nome do usuário' onChangeTermo={(e) => setTermo(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={pesquisarUsuario} acaoBtn={() => abrirModalDadosUsuario()} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Ativo', valor: 'ativo' }, { nome: 'Inativo', valor: 'inativo' }]} genero='masculino' isLoading={processando} />

        <section id='fundoContainerPagina'>
          <table id='tabelaListaContainer'>
            <thead>
              <tr>
                <th id='ladoEsquerdoContent' align='left'>Nome</th>
                <th id='emailUsuario' align='left'>E-mail</th>
                <th align='center'>Avatar</th>
                <th align='center'>Situação</th>
                <th id='tabelaAcaoUsuario' align='center'>Ação</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((usuario) => (
                <tr key={usuario.usuario.id}>
                  <td id='primeiraColuna' align='left' onClick={() => abrirModalDadosUsuario(usuario)}>{usuario.usuario.nome}</td>
                  <td id='emailUsuario' align='left' onClick={() => abrirModalDadosUsuario(usuario)}>{usuario.usuario.email}</td>
                  <td id='avatarListaUsuario' align='center' onClick={() => abrirModalDadosUsuario(usuario)}>
                    <img id='avatarUsuarioGesttor' src={usuario.usuario.avatar ? usuario.usuario.avatar : avatarDefault} alt='' />
                  </td>
                  <td align='center' onClick={() => abrirModalDadosUsuario(usuario)} className='coluna-situacao'>
                    <DivSituacao texto={usuario.usuario.situacao} cor={usuario.usuario.situacao} />
                  </td>
                  <td id='ladoDireitoContent' align='center' onClick={(e) => toggleUsuario(usuario, e)}>
                    <input
                      checked={usuario.usuario.situacao === 'ativo'}
                      className='toggleListaUsuarios'
                      id={usuario.usuario.id}
                      type="checkbox"
                      readOnly
                    />
                    <label id='labelToggleListaUsuarios' htmlFor={usuario.usuario.id}></label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </Perfil>
  )
}

export default UsuariosExternos;